import { render, staticRenderFns } from "./InitDrawer.vue?vue&type=template&id=0456d929&scoped=true"
import script from "./InitDrawer.vue?vue&type=script&lang=js"
export * from "./InitDrawer.vue?vue&type=script&lang=js"
import style0 from "./InitDrawer.vue?vue&type=style&index=0&id=0456d929&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456d929",
  null
  
)

export default component.exports